import type { ReactNode } from "react";
import { useViewport } from "../../hooks/useViewport";

export function ShellActionButton({
  label,
  onClick,
  onLongPress,
  children,
  badge,
  badgeVariant = "rank",
}: {
  label: string;
  onClick?: () => void;
  onLongPress?: () => void;
  children: ReactNode;
  badge?: string | number | null;
  badgeVariant?: "rank" | "pending";
}) {
  const { touchTarget } = useViewport();
  let pressTimer: ReturnType<typeof setTimeout> | null = null;

  const startPress = () => {
    if (!onLongPress) return;
    pressTimer = setTimeout(() => {
      onLongPress();
      pressTimer = null;
    }, 500);
  };

  const cancelPress = () => {
    if (pressTimer) {
      clearTimeout(pressTimer);
      pressTimer = null;
    }
  };

  return (
    <button
      type="button"
      className="shell-action-btn"
      aria-label={label}
      style={{ width: touchTarget, height: touchTarget }}
      onClick={onClick}
      onPointerDown={startPress}
      onPointerUp={cancelPress}
      onPointerLeave={cancelPress}
      onContextMenu={(e) => {
        if (onLongPress) e.preventDefault();
      }}
    >
      {children}
      {badge != null ? (
        <span className={`shell-action-badge ${badgeVariant}`}>{badge}</span>
      ) : null}
    </button>
  );
}
